import { request, type ApiResponse } from "../client";
import type { ImportRunOut, ImportRunSummary } from "../types/allocation";

export const allocationImports = {
  // POST /allocation-imports takes NO request body.
  run: (): Promise<ApiResponse<ImportRunOut>> =>
    request<ImportRunOut>("POST", "/api/v1/allocation-imports"),

  list: (): Promise<ApiResponse<ImportRunSummary[]>> =>
    request<ImportRunSummary[]>("GET", "/api/v1/allocation-imports"),

  get: (runId: string): Promise<ApiResponse<ImportRunOut>> =>
    request<ImportRunOut>("GET", `/api/v1/allocation-imports/${encodeURIComponent(runId)}`),
};
